import React from 'react';
import styles from '../styles/common.module.css'

const TextArea = ({ handler, touched, hasError, meta }) => (
    <div className="form-group">
        <label for="formControlInput1" className={`mb-1 ${styles.labelStyling}`}>{meta.label}</label>
        <textarea maxLength={meta.maxLengthVal} className={`form-control ${styles.modalInputStyling}`} placeholder={`${meta.label}`} {...handler()}></textarea>
        <span className="d-block text-danger">
            {touched
                && hasError("required")
                && `${meta.label} is required`}
            {hasError("email")
                && `${meta.emailErrMsg}`}
            {hasError("pattern") && `${meta.patternErrMsg}`}
            {hasError("maxLength") && `Max Length of ${meta.maxLengthVal} Exceeded`}
            {hasError("minLength") && `Min Length of ${meta.minLengthVal} Required `}
        </span>
    </div>
);

export default TextArea;